import {
  Button,
  ClickAwayListener,
  Grow,
  Paper,
  Popper,
  MenuList as Menu,
  MenuItem,
} from '@mui/material';
import AddCircle from '@mui/icons-material/AddCircle';
import React from 'react';
import { useTranslation } from 'react-i18next';
import STRING_KEYS from '../../../language/keys';
import { style } from './style';

type ContactDetailsMenuListProps = {
  onPhoneClick: () => void,
  onEmailClick: () => void,
}

export const ContactDetailsMenuList = ({
  onPhoneClick,
  onEmailClick,
}: ContactDetailsMenuListProps):JSX.Element => {
  const { t: translate } = useTranslation();
  const [open, setOpen] = React.useState(false);

  const anchorRef = React.useRef<HTMLButtonElement>(null);
  
  const prevOpen = React.useRef(open);
    
  const handleToggle = () => {
    setOpen((prev) => !prev);
  };
  
  const  handleListKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    } else if (event.key === 'Escape') {
      setOpen(false);
    }
  };
  
  const handleClose = (event: Event | React.SyntheticEvent) => {
    if (
      anchorRef.current &&
        anchorRef.current.contains(event.target as HTMLElement)
    ) {
      return;
    }
  
    setOpen(false);
  };
  
  React.useEffect(() => {
    if (prevOpen.current === true && open === false && anchorRef?.current) {
      anchorRef.current.focus();
    }
  
    prevOpen.current = open;
  }, [open]);
  
  return (
    <div>
      <Button
        sx={ style.button.sx }
        ref={ anchorRef }
        size="large"
        startIcon={ <AddCircle color="primary" /> }
        id="composition-button"
        aria-controls={ open ? 'composition-menu' : undefined }
        aria-expanded={ open ? 'true' : undefined }
        aria-haspopup="true"
        onClick={ handleToggle }
      >
        {translate(STRING_KEYS.ADD_ANOTHER)}
      </Button>
      <Popper
        open={ open }
        anchorEl={ anchorRef.current }
        role={ undefined }
        placement="bottom-start"
        transition
        disablePortal
      >
        {({ TransitionProps, placement }) => (
          <Grow
            in={ TransitionProps?.in }
            onEnter={ TransitionProps?.onEnter }
            onExited={ TransitionProps?.onExited }
            style={ {
              transformOrigin:
          placement === 'bottom-start' ? 'left top' : 'left bottom',
            } }
          >
            <Paper>
              <ClickAwayListener onClickAway={ handleClose }>
                <Menu
                  autoFocusItem={ open }
                  id="composition-menu"
                  aria-labelledby="composition-button"
                  onKeyDown={ handleListKeyDown }
                >
                  <MenuItem
                    onClick={ (event: Event | React.SyntheticEvent) => {
                      onEmailClick();
                      handleClose(event);
                    } }
                  > {translate(STRING_KEYS.ADD_EMAIL)}
                  </MenuItem>
                  <MenuItem
                    onClick={ (event: Event | React.SyntheticEvent) => {
                      onPhoneClick();
                      handleClose(event);
                    } }
                  >{translate(STRING_KEYS.ADD_PHONE_NUMBER)}
                  </MenuItem>
                </Menu>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </div>
  );
};
